import React from "react";

const Dostop = () => {
  return (
    <div className='dostop'>
      <div className='dostop-div'>
        {" "}
        <h1>DOSTOP DO SPLETNIH UČBENIKOV</h1>
      </div>

      <div className='druga-triada'>
        <h1>Druga triada</h1>
      </div>
      <div className='tretja-triada'>
        <h1>Tretja triada</h1>
      </div>
    </div>
  );
};

export default Dostop;
